import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material";

export const fileColumns: GridColDef[] = [
  { field: "excelFileName", headerName: "Archivo Excel", width: 250, align: "center", headerAlign: "center" },
  { field: "sede", headerName: "Sede", type: "string", width: 300, align: "center", headerAlign: "center" },
  { field: "newTotal", headerName: "Nuevos", type: "string", width: 70, align: "center", headerAlign: "center" },
  {
    field: "updatedTotal",
    headerName: "Actualizados",
    type: "string",
    width: 100,
    align: "center",
    headerAlign: "center",
  },
  { field: "totalRows", headerName: "Total", type: "string", width: 100, align: "center", headerAlign: "center" },
  {
    field: "userCreation",
    headerName: "Registrado por",
    type: "string",
    width: 250,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "creationDate",
    headerName: "Fecha de Registro",
    width: 150,
    type: "date",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Detalle",
    headerAlign: "center",
    renderCell: (params: any) => {
      return (
        <StyledLink to={`/survey/file-detail?codeUp=${params?.row?.sede}&excelFileName=${params?.row?.excelFileName}`}>
          <ListItemText primary='Detalle' />
        </StyledLink>
      );
    },
  },
];

export const fileDetailColumns: GridColDef[] = [
  { field: "orden", headerName: " Orden", width: 90, align: "center", headerAlign: "center" },
  {
    field: "tipoDocumento",
    headerName: "Tipo de Documento",
    type: "string",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "numeroDocumento",
    headerName: "No Documento",
    type: "string",
    width: 125,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "nombres",
    headerName: "Nombres",
    type: "string",
    width: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "apellidos",
    headerName: "Apellidos",
    type: "string",
    width: 250,
    align: "center",
    headerAlign: "center",
  },
  { field: "celular", headerName: "Celular", width: 150, type: "date", align: "center", headerAlign: "center" },
  {
    field: "fondoPensiones",
    headerName: "Fondo de Pensiones",
    type: "string",
    width: 155,
    align: "center",
    headerAlign: "center",
  },
  { field: "cesantias", headerName: "Cesantías", type: "string", width: 150, align: "center", headerAlign: "center" },
  { field: "eps", headerName: "EPS", type: "string", width: 150, align: "center", headerAlign: "center" },
  { field: "sede", headerName: "Sede", type: "string", width: 150, align: "center", headerAlign: "center" },
  { field: "cargo", headerName: "Cargo", type: "string", width: 150, align: "center", headerAlign: "center" },
  {
    field: "tipoContrato",
    headerName: "Tipo de Contrato",
    type: "string",
    width: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "fechaInicio",
    headerName: "Fecha Inicio",
    type: "string",
    width: 110,
    align: "center",
    headerAlign: "center",
  },
  { field: "fechaFin", headerName: "Fecha Fin", type: "string", width: 110, align: "center", headerAlign: "center" },
  {
    field: "empresaTemporal",
    headerName: "Empresa Temporal",
    type: "string",
    width: 400,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actionType",
    headerName: "Acción",
    type: "string",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "userCreation",
    headerName: "Registrado por",
    type: "string",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "creationDate",
    headerName: "Fecha Creación",
    type: "string",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
];

const StyledLink = styled(Link)({
  textDecoration: "none",
  color: "blue",
  cursor: "pointer",

  "&:hover": {
    textDecoration: "underline",
    color: "darkblue",
    transition: "color 0.3s ease",
  },
});
